export default "__VITE_ASSET__DxijSBol__"